import React from "react";
import { getSrcSet, getSizes, buildCmsUrl } from "../../../utils/imageHelper";


/*eslint-disable */

interface GarantiaComponentProps {
  warranty: any;
}

const GarantiaComponent: React.FC<GarantiaComponentProps> = ({ warranty }) => {
  return (
    <div className="garantia-posventa-garantia-container">
      {/* H2 - Título de la sección de garantía (comentado pero disponible) */}
      {/* <h2 className="title-garantia-posventa-garantia-container">Garantía</h2> */}
      
      <div className="cars-garantia-posventa-garantia-container">
        {warranty?.map((item: any, index: number) => (
          <div className="car" key={index}>
            <img 
              className="vehicle" 
              src={buildCmsUrl(item?.media?.url)} 
              srcSet={getSrcSet(item?.media?.url || '')}
              sizes={getSizes('400px')}
              alt={item?.title ? `Imagen de ${item.title}` : "Imagen del vehículo"} 
            />

            
            {/* H3 - Título de cada vehículo en garantía */}
            <h3 className="title">{item?.title}</h3>
            
            <img 
              className="sello" 
              src={buildCmsUrl(item?.icon?.url)} 
              srcSet={getSrcSet(item?.icon?.url || '')}
              sizes={getSizes('150px')}
              alt={item?.title ? `Sello de garantía para ${item.title}` : "Sello de garantía"} 
            />

          </div>
        ))}
      </div>
    </div>
  );
};

export default GarantiaComponent;